import { render, staticRenderFns } from "./PortfolioFilterDefaultLayout.vue?vue&type=template&id=6b9a9d7a&scoped=true&"
import script from "./PortfolioFilterDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./PortfolioFilterDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9a9d7a",
  null
  
)

export default component.exports